<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle d-block">Amostras</span>
        <h3 class="page-title d-inline">Editar</h3>
        <d-button type="button" @click.prevent="save" class="btn-accent float-right mr-2">Salvar</d-button>
      </d-col>
    </d-row>

    <!-- Content -->
    <d-row>
      <d-col lg="12">
        <sample-page :sample="sample" ref="sampleForm"/>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import SamplePage from '_modules/sample/components/SamplePage.vue';
import { MODEL } from '../components/SampleModel';

export default {
  name: 'sample-edit',
  components: {
    SamplePage,
  },
  computed: {
    sample() {
      const { sample } = this.$store.state.sample;
      if (sample) {
        return sample;
      }
      return MODEL;
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'getSample',
    ]),
    getSampleModel() {
      this.getSample(parseInt(this.$route.params.sampleId, Number));
    },
    save() {
      this.$refs.sampleForm.save();
    },
  },
  mounted() {
    if (this.$route.params.sampleId) {
      this.getSampleModel();
    }
  },
};
</script>

